module.exports = __webpack_public_path__ + "img/106.29b349d3.webp";